// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны

export interface IComparisonStatusInfoSchema {
  /** Описание статуса **/
  description: string;
  /** Статус объявления в сравнении **/
  status: EStatus;
}

export enum EStatus {
  /** Уже добавлено в сравнение **/
  'Added' = 'added',
  /** Доступно для добавления в сравнение **/
  'Available' = 'available',
  /** Недоступно для добавления в сравнение **/
  'Unavailable' = 'unavailable',
}
